export default "__VITE_ASSET__DjPeq099__"